import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { parseDateRange } from '@/utils/date'

dayjs.extend(customParseFormat)

// === Константы ===
const DATE_OUTPUT_FORMAT = 'YYYY-MM-DD'

/**
 * Добавляет диапазон дат в URLSearchParams
 */
const appendDateRange = (queryParams, value, startKey, endKey) => {
    const { start, end } = parseDateRange(value)

    if (start) {
        queryParams.append(startKey, start.format(DATE_OUTPUT_FORMAT))
    }
    if (end) {
        queryParams.append(endKey, end.format(DATE_OUTPUT_FORMAT))
    }
}

/**
 * Собирает query строку для запроса fetchOrdersCount
 * @param {Object} params - параметры для запроса
 * @param {string|null} params.type - тип фильтра ('favorite', 'printed_invoice' или null)
 * @param {string|null} params.delivered_date - дата доставки в формате "ДД.ММ.ГГГГ — ДД.ММ.ГГГГ" или "ДД.ММ.ГГГГ"
 * @param {string|null} params.created_date - дата создания заказа в формате "ДД.ММ.ГГГГ — ДД.ММ.ГГГГ" или "ДД.ММ.ГГГГ"
 * @param {Array<string>} [params.divisions] - массив ID подразделений
 * @param {Array<string>} [params.statuses] - массив ID статусов
 * @param {Array<string>} [params.types_exclude] - массив ID исключающих статусов заказов
 * @returns {string} query строка
 */
export const buildQueryParams = (params = {}) => {
    const queryParams = new URLSearchParams()

    if (params.statuses?.length) {
        queryParams.append('statuses', params.statuses.join(','))
    }

    if (params.divisions?.length) {
        params.divisions.forEach(division => {
            queryParams.append('filter[divisions]', division)
        })
    }

    if (params.shift_id) {
        queryParams.append('filter[shift_id]', params.shift_id)
    }

    if (params.type) {
        queryParams.append('filter[type]', params.type)
    }

    if (params.delivered_date) {
        appendDateRange(
            queryParams,
            params.delivered_date,
            'filter[start_delivery]',
            'filter[end_delivery]'
        )
    }

    if (params.created_date) {
        appendDateRange(
            queryParams,
            params.created_date,
            'filter[start_created_date]',
            'filter[end_created_date]'
        )
    }

    if (params.types_exclude?.length) {
        queryParams.append(
            'filter[exclude_type_id]',
            params.types_exclude.join(',')
        )
    }

    return queryParams.toString()
}
